module.exports = __webpack_public_path__ + "static/media/atman.4b17c6d9.jpg";